import { useFetch } from "./useFetch";

const HOJAS = ["Testimonios"];

export const useTestimonios = () => {
  // 1) PASAR EL ARRAY TAL CUAL, NO [HOJAS]
  const { data, cargando, error } = useFetch(HOJAS);

  // 2) Procesar la hoja "Testimonios"
  const procesar = () => {
    const sheet = data["Testimonios"];
    if (!sheet) return [];

    const [headers, ...filas] = sheet;
    const idxId = headers.indexOf("id");
    const idxNombre = headers.indexOf("Nombre");
    const idxDescripcion = headers.indexOf("Descripcion");

    return filas.map((fila) => {
      let rawDesc = fila[idxDescripcion] || "";

      // Quitamos comillas envolventes
      if (rawDesc.startsWith('"') && rawDesc.endsWith('"')) {
        rawDesc = rawDesc.slice(1, -1);
      }

      return {
        id: parseInt(fila[idxId], 10),
        nombre: fila[idxNombre] || "Anónimo",
        descripcion: rawDesc,
      };
    });
  };

  const testimonios = !cargando && !error ? procesar() : [];

  return { testimonios, cargando, error };
};
